import React from 'react';
import styled from '@emotion/styled';

import { Button as StandardButton } from '~/src/components/buttons';

const YIButton: React.FC<React.ComponentProps<typeof StandardButton>> = props => (
  <StandardButton kind="turquoise" {...props} />
);

export const Button = styled(YIButton)`
  display: flex;
  justify-content: flex-start !important;
  gap: 8px;
  background: transparent !important;
  font-size: 16px !important;
  height: fit-content !important;
  padding: 8px 0 !important;
  width: 100% !important;
  margin: 4px 0px !important;
`;
